import React, { useState, useEffect, useContext, useActionState } from "react";
import "../../styles/global.css";
import {
  Paper,
  Toolbar,
  InputAdornment,
  TableBody,
  TableRow,
  TableCell,
  Select,
  Chip,
  Grid,
  MenuItem,
  Typography,
  TextField,
} from "@material-ui/core";
import Controls from "../../components/controls/Controls";
import Axios from "axios";
import useTable from "../../components/useTable";
import { BatteryUnknownOutlined, Check, Height, HeightOutlined, Search, Style } from "@material-ui/icons";
import DetailProduct from "./detail";
import WarningIcon from "@material-ui/icons/Warning";
import ProductCompletion from "../management/completion";
// import ProductDeletion from "../management/deletion";
import { baseUrl } from "../../config/const";
// import ArchiveProduct from "../management/archiveProduct";
import { AuthContext } from "../../AppContext";
import Checkbox from "@material-ui/core/Checkbox";
import { Autocomplete } from "@material-ui/lab";

export default function CompleteProducts() {
  const { state, dispatch } = useContext(AuthContext);
  const headCells = [
    // { id: "select", label: "", disableSorting : true },
    { id: "sku", label: "SKU" },
    { id: "pname", label: "Product Name", disableSorting: true },
    { id: "brand", label: "Brand" },
    { id: "koleksi", label: "Koleksi", disableSorting: true },
    { id: "type", label: "Tipe Produk", disableSorting: true },
    { id: "usage", label: "Peruntukkan Produk", disableSorting: true },
    { id: "gender", label: "Gender", disableSorting: true },
    { id: "age_group", label: "Age Group", disableSorting: true },
    { id: "harga", label: "Harga"},
    { id: "stok", label: "Stok"},
    { id: "tglms", label: "Date Registered"},
    
  ];
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  // supaya bisa text filtering
  const filteredRecords = filterFn.fn(state.incompleteProductList);
  // helper untuk SKUs' filtered
  const [searchText, setSearchText] = useState("");
  const isFiltering = searchText.trim() !== "";
  const filteredSKUs = isFiltering ? filteredRecords.map(r => r.sku) : [];
  const [selectedSKU, setSelectedSKU] = useState([]);

  const allFilteredSelected = isFiltering && filteredSKUs.length > 0 && filteredSKUs.every(sku => selectedSKU.includes(sku));

  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
    location: "",
  });


  /**
   * return results of useForm helper method
   * @param records are the data from db
   * @param headCells header of the table
   * @param filterFn filtering function that carries the records
   */
  const { TblHead, TblContainer, TblPagination, recordsAfterPagingAndSorting } =
    useTable(filteredRecords, headCells, {
      fn: items => items
    });

  /**
   * @returns records of all products
   */
  const getCompleteProducts = async () => {
    await Axios.get(`${baseUrl}/getCompleteProducts`)
      .then((response) => {
        dispatch({
          type: "UPDATE_LIST",
          payload: {
            incompleteProductList: response.data.records,
          },
        });
      })
      .catch((err) => {
        setNotify({
          message: "error",
          isOpen: true,
          type: "error",
        });
      });
  };


  /**
   *
   * @param {*} e indicates the search event
   */
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchText(value);
    // let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (value === "") {
          return items;
        } else {
          return items.filter((x) => x.sku.includes(value));
        }
      },
    });
  };
  useEffect(() => {
    getCompleteProducts();
  }, []);


  return (
    
    <div className="incomplete-product">
      <h1>Completed Product List</h1>
      <Paper elevation={2}>
        <Toolbar>
          <Controls.Label label="Search: " />
          <Controls.Input
            inputprops={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
            onChange={handleSearch}
            placeholder="CARI KODE BARCODE..."
          />      


        </Toolbar>
        <TblContainer>
          <TblHead />
          <TableBody>
            {recordsAfterPagingAndSorting().map((item) => (
              <TableRow key={item.sku} hover>

                <TableCell
                  style={{ cursor: "pointer" }}
                  // onClick={() => {
                  //   setOpenPopup(true);
                  //   setDetailItem(item);
                  // }}
                >
                  {item.sku}
                </TableCell>
  
                <TableCell>{item.pname}</TableCell>
                <TableCell>{item.brand}</TableCell>
                <TableCell>{item.koleksi}</TableCell>
                <TableCell>{item.type}</TableCell>
                <TableCell>{item.usage}</TableCell>
                <TableCell>{item.gender}</TableCell>
                <TableCell>{item.age_group}</TableCell>
                <TableCell>Rp. {item.harga}</TableCell>
                <TableCell>{item.stok}</TableCell>
                <TableCell>{(item.tglms
                    ? new Date(item.tglms).toLocaleDateString("id-ID")
                    : "-")}
                    </TableCell>
                {/* <TableCell>
                  <ProductCompletion
                    item={item}
                    location="/products/incompleteProducts"
                  />
                  <ProductDeletion
                    productStatus="incomplete"
                    param={item.sku}
                    location="/products/incompleteProducts"
                  />
                </TableCell> */}
              </TableRow>
            ))}
          </TableBody>
        </TblContainer>
        <TblPagination />
      </Paper>
      <Controls.Notification notify={notify} setNotify={setNotify} />

    </div>
  );
}


